import React from 'react';
import PillToggle from '../UI/PillToggle';

/**
 * AM/PM for leave first/last day — delegates to design-system `PillToggle` (Type 6, `compact`).
 *
 * DS references:
 * - `design-system-reference.md` § Segmented Control System (AM/PM example)
 * - Same file § Type 6: Toggle / Segmented Control → `PillToggle` + `variant="compact"` for AM/PM
 *
 * @param {'AM'|'PM'} value
 * @param {(p: 'AM'|'PM') => void} onChange
 * @param {'admin'|'employee'} [theme='employee']
 * @param {string} [ariaLabel]
 * @param {boolean} [stretch=false] — `w-full` under a stacked form field; default `w-24` beside a date
 * @param {string} [className] — merged onto `pill-toggle-container`
 */
const HALF_DAY_OPTIONS = [
  { id: 'AM', label: 'AM' },
  { id: 'PM', label: 'PM' },
];

const LeaveHalfDaySegmentedControl = ({
  value,
  onChange,
  theme = 'employee',
  ariaLabel,
  stretch = false,
  className = '',
}) => {
  const focusRing =
    theme === 'admin'
      ? 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-1'
      : 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1';

  return (
    <PillToggle
      value={value}
      onChange={onChange}
      options={HALF_DAY_OPTIONS}
      variant="compact"
      theme={theme}
      ariaLabel={ariaLabel || 'Morning or afternoon'}
      fullWidth
      className={`${stretch ? 'w-full' : 'w-24'} flex-shrink-0 ${className}`.trim()}
      buttonClassName={focusRing}
    />
  );
};

export default LeaveHalfDaySegmentedControl;
